module.exports = __webpack_public_path__ + "static/media/cart.8f1abf20.svg";